var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClickup({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.36L6.322 16c1.765 2.136 3.638 3.12 5.726 3.12 2.076 0 3.899-.973 5.584-3.092L21 18.331C18.57 21.386 15.547 23 12.048 23 8.561 23 5.51 21.397 3 18.36z",
    fill: "url(#clickup_svg__paint0_linear_7858_24896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.023 6.727L5.85 12 3 8.72 12.035 1 21 8.725l-2.865 3.269-6.112-5.267z",
    fill: "url(#clickup_svg__paint1_linear_7858_24896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clickup_svg__paint0_linear_7858_24896",
    x1: 3,
    y1: 24.26,
    x2: 21,
    y2: 24.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8930FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49CCF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clickup_svg__paint1_linear_7858_24896",
    x1: 3,
    y1: 13.981,
    x2: 21,
    y2: 13.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF02F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC800"
  })))));
}

export default SvgClickup;